import { render, staticRenderFns } from "./TableHeader.vue?vue&type=template&id=db35f750&scoped=true"
import script from "./TableHeader.vue?vue&type=script&lang=js"
export * from "./TableHeader.vue?vue&type=script&lang=js"
import style0 from "./TableHeader.vue?vue&type=style&index=0&id=db35f750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db35f750",
  null
  
)

export default component.exports